document.addEventListener('DOMContentLoaded', function() {
  // Helper function for currency formatting
  const formatCurrency = (number) => {
    return number.toLocaleString("en", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  // SQM input handler
  const sqmInput = document.getElementById('SQM');
  if (sqmInput) {
    sqmInput.addEventListener('input', function() {
      const grids = Math.ceil(this.value * 4);
      const quantityInput = document.querySelector('input[name="quantity"]');
      if (quantityInput) {
        quantityInput.value = grids;
      }
      
      const priceElement = document.getElementById('prhdn');
      const salePriceElement = document.getElementById('sprhdn');
      const currencyElement = document.getElementById('cur');
      
      const price = priceElement ? parseFloat(priceElement.value) : 0;
      const salePrice = salePriceElement ? salePriceElement.value : '';
      const currency = currencyElement ? currencyElement.value : '';
      
      // Calculate discount
      const discount = grids > 240 ? 1 : 1;
      
      // Update current price
      const currentPrice = formatCurrency(price * grids * discount);
      const priceItemSale = document.querySelector('.price-item--sale');
      if (priceItemSale) {
        priceItemSale.innerHTML = `${currency}${currentPrice} <small>inc. VAT</small>`;
      }

      // Update buy now button
      const buyNowButton = document.querySelector('.buynowprice');
      if (buyNowButton) {
        buyNowButton.innerHTML = `<i class="fa-solid fa-basket-shopping"></i> Buy <d class="mobile-hidden">Now</d> | ${currency}${currentPrice}`;
      }

      // Update sale price if exists
      if (salePrice) {
        const formattedSalePrice = formatCurrency(parseFloat(salePrice) * grids);
        const priceItemRegular = document.querySelector('.price-item--regular');
        if (priceItemRegular) {
          priceItemRegular.innerHTML = `${currency}${formattedSalePrice}`;
        }
      }
    });
  }

  // Plus/Minus buttons
  const menosButton = document.querySelector('.menos');
  if (menosButton) {
    menosButton.addEventListener('click', function() {
      const sqmInput = document.getElementById('SQM');
      if (sqmInput) {
        sqmInput.stepDown();
        sqmInput.dispatchEvent(new Event('input'));
      }
    });
  }

  const masButton = document.querySelector('.mas');
  if (masButton) {
    masButton.addEventListener('click', function() {
      const sqmInput = document.getElementById('SQM');
      if (sqmInput) {
        sqmInput.stepUp();
        sqmInput.dispatchEvent(new Event('input'));
      }
    });
  }

  // Calculator toggle
  const ssclButton = document.querySelector('.sscl');
  if (ssclButton) {
    ssclButton.addEventListener('click', function() {
      const calculator = document.getElementById('sqmcalc');
      if (calculator) {
        calculator.style.display = calculator.style.display === 'none' ? 'block' : 'none';
      }
    });
  }

  const closeCalcButton = document.querySelector('.closecalca');
  if (closeCalcButton) {
    closeCalcButton.addEventListener('click', function() {
      const calculatorToggle = document.querySelector('.sscl');
      if (calculatorToggle) {
        calculatorToggle.click();
      }
    });
  }

  // Calculator input handlers
  const updateCalculations = () => {
    const lengthInput = document.getElementById('lng');
    const widthInput = document.getElementById('wdt');
    
    const length = lengthInput ? parseFloat(lengthInput.value) || 0 : 0;
    const width = widthInput ? parseFloat(widthInput.value) || 0 : 0;
    
    // Update width and length fields
    document.querySelectorAll('.wdt').forEach(el => {
      if (el) el.value = width;
    });
    document.querySelectorAll('.lng').forEach(el => {
      if (el) el.value = length;
    });
    
    const sqm = length * width;
    const grids = sqm * 4;
    const stone = grids * 20;
    
    // Update displays
    const stoneElement = document.querySelector('.stone');
    const totalSqmElement = document.querySelector('.totalsqm');
    const gridsElement = document.querySelector('.grids');
    
    if (stoneElement) stoneElement.innerHTML = stone.toString();
    if (totalSqmElement) totalSqmElement.innerHTML = sqm.toString();
    if (gridsElement) gridsElement.innerHTML = `${grids} grid${grids > 1 ? 's' : ''}`;
  };

  // Add listeners to calculator inputs
  document.querySelectorAll('.calcin').forEach(input => {
    if (input) {
      input.addEventListener('input', updateCalculations);
    }
  });

  document.querySelectorAll('.borderless').forEach(input => {
    if (input) {
      input.addEventListener('input', function() {
        const widthField = document.querySelector('.wdt');
        const lengthField = document.querySelector('.lng');
        
        const width = widthField ? widthField.value : '';
        const length = lengthField ? lengthField.value : '';
        
        const widthInput = document.getElementById('wdt');
        const lengthInput = document.getElementById('lng');
        
        if (widthInput) widthInput.value = width;
        if (lengthInput) lengthInput.value = length;
        
        updateCalculations();
      });
    }
  });
});